module.exports = __webpack_public_path__ + "img/vegetable-okra-190x100.baa92a9b.jpg";